(function () {
    'use strict';

    angular.module('crewProfile')
        .component('airportRecencyTable', {
            templateUrl: 'profile/components/airport-recency-table-component.html',
            controller: AirportRecencyTableController,
            bindings: {
                recencyData: '<'
            }
        });

    AirportRecencyTableController.$inject = ['$document', '$timeout'];

    function AirportRecencyTableController($document, $timeout) {
        var ctrl = this;

        ctrl.sortedRecencyData = [];
        ctrl.sortColumn = null;
        ctrl.sortDirection = null;
        ctrl.searchVisible = false;
        ctrl.searchTerm = '';
        ctrl.flightSearchVisible = false;
        ctrl.flightNumberSearchTerm = '';
        ctrl.flightSegmentSearchVisible = false;
        ctrl.flightSegmentSearchTerm = '';
        ctrl.filteredData = [];
        ctrl.statusFilterVisible = false;
        ctrl.uniqueStatuses = [];
        ctrl.selectedStatuses = {};
        ctrl.statusFilters = [];
        ctrl.aircraftTypeFilterVisible = false;
        ctrl.uniqueAircraftTypes = [];
        ctrl.selectedAircraftTypes = {};
        ctrl.aircraftTypeFilters = [];
        ctrl.operationTypeFilterVisible = false;
        ctrl.uniqueOperationTypes = [];
        ctrl.selectedOperationTypes = {};
        ctrl.operationTypeFilters = [];

        ctrl.$onInit = function () {
            if (ctrl.recencyData) {
                ctrl.filteredData = angular.copy(ctrl.recencyData);
                ctrl.sortedRecencyData = angular.copy(ctrl.recencyData);
                ctrl.getUniqueStatuses();
                ctrl.getUniqueAircraftTypes();
                ctrl.getUniqueOperationTypes();
            }

            $document.on('click', ctrl.handleDocumentClick);
        };

        ctrl.$onDestroy = function () {
            $document.off('click', ctrl.handleDocumentClick);
        };

        ctrl.$onChanges = function (changes) {
            if (changes.recencyData && changes.recencyData.currentValue) {
                ctrl.filteredData = angular.copy(changes.recencyData.currentValue);
                ctrl.getUniqueStatuses();
                ctrl.getUniqueAircraftTypes();
                ctrl.getUniqueOperationTypes();
                ctrl.applyFilterAndSort();
            }
        };

        ctrl.handleDocumentClick = function () {
            if (ctrl.searchVisible || ctrl.flightSearchVisible || ctrl.flightSegmentSearchVisible || ctrl.statusFilterVisible || ctrl.aircraftTypeFilterVisible || ctrl.operationTypeFilterVisible) {
                $timeout(function () {
                    ctrl.searchVisible = false;
                    ctrl.flightSearchVisible = false;
                    ctrl.flightSegmentSearchVisible = false;
                    ctrl.statusFilterVisible = false;
                    ctrl.aircraftTypeFilterVisible = false;
                    ctrl.operationTypeFilterVisible = false;
                });
            }
        };

        ctrl.toggleSearch = function (event) {
            event.stopPropagation();
            ctrl.searchVisible = !ctrl.searchVisible;

            if (ctrl.searchVisible) {
                $timeout(function () {
                    var input = document.querySelector('.airport-recency-table .search-input');
                    if (input) {
                        input.focus();
                    }
                }, 0);
            }
        };

        ctrl.toggleFlightSearch = function (event) {
            event.stopPropagation();
            ctrl.flightSearchVisible = !ctrl.flightSearchVisible;

            if (ctrl.flightSearchVisible) {
                $timeout(function () {
                    var input = document.querySelector('.airport-recency-table .flight-search-input');
                    if (input) {
                        input.focus();
                    }
                }, 0);
            }
        };

        ctrl.toggleFlightSegmentSearch = function (event) {
            event.stopPropagation();
            ctrl.flightSegmentSearchVisible = !ctrl.flightSegmentSearchVisible;

            if (ctrl.flightSegmentSearchVisible) {
                $timeout(function () {
                    var input = document.querySelector('.airport-recency-table .flight-segment-search-input');
                    if (input) {
                        input.focus();
                    }
                }, 0);
            }
        };

        ctrl.onSearchKeyDown = function (event) {
            if (event.keyCode === 27) {
                ctrl.searchVisible = false;
                ctrl.searchTerm = '';
                ctrl.filterByAirportCode();
            }
        };

        ctrl.onFlightSearchKeyDown = function (event) {
            if (event.keyCode === 27) {
                ctrl.flightSearchVisible = false;
                ctrl.flightNumberSearchTerm = '';
                ctrl.filterByFlightNumber();
            }
        };

        ctrl.onFlightSegmentSearchKeyDown = function (event) {
            if (event.keyCode === 27) {
                ctrl.flightSegmentSearchVisible = false;
                ctrl.flightSegmentSearchTerm = '';
                ctrl.filterByFlightSegment();
            }
        };

        ctrl.filterByAirportCode = function () {
            ctrl.applyFilters();
        };

        ctrl.filterByFlightNumber = function () {
            ctrl.applyFilters();
        };

        ctrl.filterByFlightSegment = function () {
            ctrl.applyFilters();
        };

        ctrl.filterByStatus = function () {
            // Update statusFilters array from selectedStatuses object
            ctrl.statusFilters = [];
            angular.forEach(ctrl.selectedStatuses, function (value, key) {
                if (value) {
                    ctrl.statusFilters.push(key);
                }
            });
            ctrl.applyFilters();
        };

        ctrl.filterByAircraftType = function () {
            // Update aircraftTypeFilters array from selectedAircraftTypes object
            ctrl.aircraftTypeFilters = [];
            angular.forEach(ctrl.selectedAircraftTypes, function (value, key) {
                if (value) {
                    ctrl.aircraftTypeFilters.push(key);
                }
            });
            ctrl.applyFilters();
        };

        ctrl.filterByOperationType = function () {
            ctrl.operationTypeFilters = [];
            angular.forEach(ctrl.selectedOperationTypes, function (value, key) {
                if (value) {
                    ctrl.operationTypeFilters.push(key);
                }
            });
            ctrl.applyFilters();
        };

        ctrl.applyFilters = function () {
            // Start with all data
            ctrl.filteredData = angular.copy(ctrl.recencyData);

            // Apply airport code search filter
            if (ctrl.searchTerm && ctrl.searchTerm.trim() !== '') {
                var searchLower = ctrl.searchTerm.toLowerCase().trim();
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return item.airportCode && item.airportCode.toLowerCase().indexOf(searchLower) !== -1;
                });
            }

            // Apply flight number search filter
            if (ctrl.flightNumberSearchTerm && ctrl.flightNumberSearchTerm.trim() !== '') {
                var flightSearchLower = ctrl.flightNumberSearchTerm.toLowerCase().trim();
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return item.flightNumber && item.flightNumber.toLowerCase().indexOf(flightSearchLower) !== -1;
                });
            }

            // Apply flight segment search filter
            if (ctrl.flightSegmentSearchTerm && ctrl.flightSegmentSearchTerm.trim() !== '') {
                var flightSegmentSearchLower = ctrl.flightSegmentSearchTerm.toLowerCase().trim();
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return item.flightSegment && item.flightSegment.toLowerCase().indexOf(flightSegmentSearchLower) !== -1;
                });
            }

            // Apply aircraft type filter
            if (ctrl.aircraftTypeFilters.length > 0) {
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return ctrl.aircraftTypeFilters.indexOf(item.aircraftType) !== -1;
                });
            }

            // Apply operation type filter
            if (ctrl.operationTypeFilters.length > 0) {
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return ctrl.operationTypeFilters.indexOf(item.operationType) !== -1;
                });
            }

            // Apply status filter
            if (ctrl.statusFilters.length > 0) {
                ctrl.filteredData = ctrl.filteredData.filter(function (item) {
                    return ctrl.statusFilters.indexOf(item.status) !== -1;
                });
            }

            ctrl.applyFilterAndSort();
        };

        ctrl.applyFilterAndSort = function () {
            ctrl.sortedRecencyData = angular.copy(ctrl.filteredData);
            if (ctrl.sortColumn) {
                ctrl.applySorting();
            }
        };

        ctrl.sortBy = function (column) {
            if (ctrl.sortColumn === column) {
                if (ctrl.sortDirection === 'asc') {
                    ctrl.sortDirection = 'desc';
                } else if (ctrl.sortDirection === 'desc') {
                    ctrl.sortColumn = null;
                    ctrl.sortDirection = null;
                    ctrl.sortedRecencyData = angular.copy(ctrl.filteredData);
                    return;
                }
            } else {
                ctrl.sortColumn = column;
                ctrl.sortDirection = 'asc';
            }

            ctrl.applySorting();
        };

        ctrl.applySorting = function () {
            if (!ctrl.sortColumn) {
                return;
            }

            ctrl.sortedRecencyData.sort(function (a, b) {
                var valueA = a[ctrl.sortColumn];
                var valueB = b[ctrl.sortColumn];

                if (ctrl.sortColumn === 'lastOperated' || ctrl.sortColumn === 'validUntil') {
                    valueA = ctrl.parseDate(valueA);
                    valueB = ctrl.parseDate(valueB);
                }

                var comparison = 0;
                if (valueA < valueB) {
                    comparison = -1;
                } else if (valueA > valueB) {
                    comparison = 1;
                }

                return ctrl.sortDirection === 'asc' ? comparison : -comparison;
            });
        };

        ctrl.parseDate = function (dateString) {
            if (!dateString) return new Date(0);
            var parts = dateString.split(' ');
            var dateParts = parts[0].split('/');
            var timeParts = parts[1] ? parts[1].split(':') : ['00', '00'];
            return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);
        };

        ctrl.isSortedBy = function (column, direction) {
            return ctrl.sortColumn === column && ctrl.sortDirection === direction;
        };

        ctrl.toggleStatusFilter = function (event) {
            event.stopPropagation();
            ctrl.statusFilterVisible = !ctrl.statusFilterVisible;
        };

        ctrl.toggleAircraftTypeFilter = function (event) {
            event.stopPropagation();
            ctrl.aircraftTypeFilterVisible = !ctrl.aircraftTypeFilterVisible;
        };

        ctrl.toggleOperationTypeFilter = function (event) {
            event.stopPropagation();
            ctrl.operationTypeFilterVisible = !ctrl.operationTypeFilterVisible;
        };

        ctrl.getUniqueStatuses = function () {
            if (!ctrl.recencyData) {
                ctrl.uniqueStatuses = [];
                return;
            }

            var statusSet = {};
            ctrl.recencyData.forEach(function (item) {
                if (item.status) {
                    statusSet[item.status] = true;
                }
            });

            ctrl.uniqueStatuses = Object.keys(statusSet).sort();
        };

        ctrl.getUniqueAircraftTypes = function () {
            if (!ctrl.recencyData) {
                ctrl.uniqueAircraftTypes = [];
                return;
            }

            var aircraftTypeSet = {};
            ctrl.recencyData.forEach(function (item) {
                if (item.aircraftType) {
                    aircraftTypeSet[item.aircraftType] = true;
                }
            });

            ctrl.uniqueAircraftTypes = Object.keys(aircraftTypeSet).sort();
        };

        ctrl.getUniqueOperationTypes = function () {
            if (!ctrl.recencyData) {
                ctrl.uniqueOperationTypes = [];
                return;
            }

            var operationTypeSet = {};
            ctrl.recencyData.forEach(function (item) {
                if (item.operationType) {
                    operationTypeSet[item.operationType] = true;
                }
            });

            ctrl.uniqueOperationTypes = Object.keys(operationTypeSet).sort();
        };
    }
})();
